// extracted by mini-css-extract-plugin
export var leftAlign = "_1s-2";
export var popper = "_1s-0";
export var subtitle = "_1s-1";